// extracted by mini-css-extract-plugin
export default {"cls1":"UngatedWorkCardDownloadCount-cls1_Dhh","cls2":"UngatedWorkCardDownloadCount-cls2_sks UngatedWorkCardDownloadCount-cls1_Dhh"};